import {AxiosResponse} from "axios";
import http from "./httpRequest";

class FilesService {
	async getFile(fileUrl: string) {
		return await http.get(`/files/${fileUrl}`, {
			responseType: 'blob'
		});
	}

	processFileToDownload(response: AxiosResponse,fileName: string) {
		if (response.status !== 200) return;
		const contentDisposition = response.headers['content-disposition'];

		if (contentDisposition) {
			const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
			if (fileNameMatch?.length === 2) {
				fileName = fileNameMatch[1];
			}
		}

		const link = document.createElement('a');
		link.href = window.URL.createObjectURL(new Blob([response.data]));

		link.setAttribute('download', fileName);
		link.click();
	}

	openFileOnEmergentWindow(filePath: string, windowName = 'emergentWindow', windowFeatures = 'width=600,height=700') {
		let baseApiUrl = process.env.NODE_ENV === 'development' ?
			'http://localhost:8000/api/files/shared/' :
			window.location.origin + process.env.REACT_APP_API_URL + '/files/shared/';
		window.open(baseApiUrl + filePath, windowName, windowFeatures);
	}
}

export default new FilesService();